export default {
    install(Vue) {
        Vue.prototype.$googleAuth = {
            clientId: '219126943335-194lbb2fj6hp3in34891ansuqpbsbnnn.apps.googleusercontent.com',

            init() {
                return new Promise((resolve) => {
                    if (window?.google?.accounts?.oauth2) {
                        resolve();
                    } else {
                        const checkGoogle = setInterval(() => {
                            if (window?.google?.accounts?.oauth2) {
                                clearInterval(checkGoogle);
                                resolve();
                            }
                        }, 100);

                        setTimeout(() => {
                            clearInterval(checkGoogle);
                            if (window?.google?.accounts?.oauth2) {
                                resolve();
                            } else {
                                console.error('Google API failed to load');
                            }
                        }, 10000);
                    }
                });
            },

            async signIn() {
                await this.init();

                return new Promise((resolve, reject) => {
                    try {
                        const client = window.google.accounts.oauth2.initTokenClient({
                            client_id: this.clientId,
                            scope: 'profile email',
                            callback: async (tokenResponse) => {
                                if (tokenResponse && tokenResponse.access_token) {
                                    try {
                                        const userInfo = await this.getUserInfo(tokenResponse.access_token);
                                        resolve(userInfo);
                                    } catch (error) {
                                        reject(error);
                                    }
                                } else {
                                    reject(new Error('No access token received'));
                                }
                            },
                            error_callback: (error) => {
                                reject(error);
                            }
                        });

                        client.requestAccessToken();
                    } catch (error) {
                        reject(new Error('Google API not loaded properly'));
                    }
                });
            },

            async signOut() {
                await this.init();

                return new Promise((resolve) => {
                    if (window?.google?.accounts?.id) {
                        window.google.accounts.id.disableAutoSelect();
                    }
                    resolve();
                });
            },

            async getUserInfo(accessToken) {
                const response = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch user info');
                }

                const data = await response.json();
                return {
                    email: data.email,
                    name: data.name,
                    given_name: data.given_name,
                    family_name: data.family_name,
                    picture: data.picture
                };
            }
        };
    }
};